// extracted by mini-css-extract-plugin
module.exports = {"EditoCard":"styles_EditoCard__gAsix","image":"styles_image__fLnFv","title":"styles_title___obd9","pin":"styles_pin__BaFtz","ratio":"styles_ratio__bVxdd"};